import { AssistantEphemeralContextSubType } from '../types.js';
import { isString } from 'lodash-es';

const folderScope = [
  AssistantEphemeralContextSubType.Connection,
  AssistantEphemeralContextSubType.Folder,
  AssistantEphemeralContextSubType.Space
];
const resourceScope = [
  AssistantEphemeralContextSubType.File
];
const convertAssistantContextToAPIScope = (context, ephemeralContextOption) => {
  const useNewContext = context.some((c) => c.type !== "ephemeral");
  if (useNewContext) {
    const isTextOnly = context.every((c) => c.subType === "text");
    if (isTextOnly) {
      return {
        scope: "user",
        textSnippets: context.map((c) => c.value)
      };
    }
    return {
      scope: "resources",
      resourceIds: context.filter((c) => c.subType === "resourceId").map((c) => c.value),
      textSnippets: context.filter((c) => c.subType === "text").map((c) => c.value)
    };
  }
  if (folderScope.includes(ephemeralContextOption.subType) && isString(ephemeralContextOption.value)) return {
    scope: "folder",
    folderId: ephemeralContextOption.value
  };
  if (resourceScope.includes(ephemeralContextOption.subType)) return {
    scope: "resource",
    resourceIds: [
      ephemeralContextOption.value
    ]
  };
  return {
    scope: "user"
  };
};

export { convertAssistantContextToAPIScope };
//# sourceMappingURL=convertAssistantContextToAPIScope.js.map
